import { render, staticRenderFns } from "./insertion.vue?vue&type=template&id=6e1cd544&scoped=true&"
import script from "./insertion.vue?vue&type=script&lang=js&"
export * from "./insertion.vue?vue&type=script&lang=js&"
import style0 from "./insertion.vue?vue&type=style&index=0&id=6e1cd544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1cd544",
  null
  
)

export default component.exports